import * as yup from 'yup'
import { useEffect } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../../component/form/form-layout'

const AddItemForm = ({ onClose = () => { }, onError = () => { }, onSuccess = () => {}, onSubmit = () => { }, currentData, Style, dropdowns }) => {
    const apiCall = useApiCall();

    useEffect(() => {
        if (!currentData?.id) return;

        formik.setValues({
            name: currentData?.name || "",
            category_id: currentData?.category_id,
            status: currentData?.status,
            notes: currentData?.notes
        });
    }, [currentData]);

    const validationSchema = yup.object().shape({
        name: yup.string().required('This Field is required'),
        category_id: yup.string().required('This Field is required'),
        status: yup.string().required('This Field is required'),
        notes: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            category_id: "",
            status: "",
            notes: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "item_id": currentData?.id,
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "name": values?.name,
                "category_id": values?.category_id,
                "status": Number(values?.status),
                "notes": values?.notes
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `update-supply-item` : `store-supply-item`, data: apiData });
                onSubmit();
                onSuccess(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper width='100%'>
                            <FormLabel required>Item Name</FormLabel>
                            <input
                                type={'text'}
                                name={'name'}
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                placeholder='Category Name'
                            />
                            {formik.touched.name && formik.errors.name && (
                                <FeildError>{formik.errors.name}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Status</FormLabel>

                            <SelectSearch
                                name="status"
                                placeholder="- Select Status -"
                                onChange={(val) => {formik.setFieldValue("status", val);}}
                                value={formik.values.status}
                                options={[
                                    {label: "Active", value: 1},
                                    {label: "In Active", value: 0},
                                ]}
                            />
                            {formik.touched.status && formik.errors.status && (
                                <FeildError>{formik.errors.status}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Category</FormLabel>

                            <SelectSearch
                                name="category_id"
                                placeholder="- Select Category -"
                                onChange={(val) => {formik.setFieldValue("category_id", val);}}
                                value={formik.values.category_id}
                                options={dropdowns?.categories?.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.category_id && formik.errors.category_id && (
                                <FeildError>{formik.errors.category_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Notes</FormLabel>
                            <textarea
                                type={'text'}
                                name={'notes'}
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                                placeholder='Write Notes here...'
                            />
                            {formik.touched.notes && formik.errors.notes && (
                                <FeildError>{formik.errors.notes}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                </div>
            </form>
        </>
    )
}

export default AddItemForm
